<div id="custom-overlay" [style.display]="splash ? 'flex': 'none'">
  <div class="flb">
    <div class="Aligner-item Aligner-item--top"></div>
    <img src="assets/imgs/certinergie_logo.gif">
    <div class="Aligner-item Aligner-item--bottom"></div>
  </div>
</div>
<app-templates></app-templates>
<router-outlet></router-outlet>